import { ProcedureType } from "@graffer-inc/cloud-gov-core";

import { GroupPermissionAttached } from "../group/grp_resource";
import { PermissionSet } from "../rbac/permission_set";
import { KintoneExportPermissions } from "../rbac/rbac";

export class KintoneExportSettingGroupPermissionAttached
  implements GroupPermissionAttached
{
  public readonly formResource: ProcedureType;

  constructor(formResource: ProcedureType) {
    this.formResource = formResource;
  }

  public resolvePermission(groupId: string): PermissionSet {
    return new PermissionSet(
      this.formResource.groupIds.includes(groupId)
        ? KintoneExportPermissions
        : [],
    );
  }
}
